<template>
<div>
  <!-- NAVIGATION MENU -->
  <button class="btn_menu" :class="{ active: $store.state.menu.active, close: !$store.state.menu.active}" @click="toggleMenu"></button>
  <nav>
    <ul>
      <li>
        <router-link to="/"><img src="../assets/img/icon-home.png" /></router-link>
      </li>
      <li><a :href="this.urlComprendreCartoradio" target="_blank">{{ $t("message['Comprendre Cartoradio']") }}</a></li>
      <li><a :href="this.urlGlossaire" target="_blank">{{ $t("message['Glossaire']") }}</a></li>
      <li><a :href="this.urlFAQ" target="_blank">{{ $t("message['FAQ']") }}</a></li>
      <install-pwa/>
    </ul>
  </nav>
</div>
</template>

<script>
import InstallPwa from './InstallPwa'
import '../assets/css/menu.css'

export default {
  name: 'CrMenu',
  components: {
    InstallPwa
  },
  data() {
    return {}
  },
  computed: {
    urlFAQ() {
      return this.$store.state.paramUrl.URL_FAQ ? this.$store.state.paramUrl.URL_FAQ : ''
    },
    urlComprendreCartoradio() {
      return this.$store.state.paramUrl.URL_COMPRENDRE_CARTORADIO ? this.$store.state.paramUrl.URL_COMPRENDRE_CARTORADIO : ''
    },
    urlGlossaire() {
      return this.$store.state.paramUrl.URL_GLOSSAIRE ? this.$store.state.paramUrl.URL_GLOSSAIRE : ''
    }
  },
  methods: {
    toggleMenu: function(event) {
      this.$store.dispatch('menuToggle')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
